import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import EditCarwash from './EditCarwash'; // Adjust the path as necessary

const stripePromise = loadStripe(process.env.REACT_APP_SUPERADMIN_STRIPE_PUBLIC_KEY || "");

const EditCarwashWrapper = (props: any) => (
  <Elements stripe={stripePromise}>
    <EditCarwash {...props} />
  </Elements>
);

export default EditCarwashWrapper;
